import { Injectable, Inject } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { BehaviorSubject, filter, Observable, switchMap, take } from 'rxjs';
import { L10N_LOCALE, L10nLocale } from 'angular-l10n';

import { AuthenticationService } from '../services/authentication.service';
import { getTimeZoneOffset } from '../shared/utils';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
   newToken: any;
   private refreshTokenInProgress = false;
   // Refresh Token Subject tracks the current token, or is null if no token is currently
   // available (e.g. refresh pending).
   private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(
      null
   );
   constructor(
      private authenticationService: AuthenticationService,
      @Inject(L10N_LOCALE) public locale: L10nLocale
   ) { }

   intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
      // add authorization header with jwt token if available
      const currentUser = this.authenticationService.currentUserValue;

      // console.log('kezd');
      // console.log(request);

      // Set the language
      // Set CORS
      // Time zone
      // Platform
      request = request.clone({
         setHeaders: {
            "Content-Language": this.locale.language,
            "Access-Control-Allow-Origin": '*',
            "tz-offset": getTimeZoneOffset(),
            "Platform": "Predem"
         }
      });


      if (currentUser && currentUser.token && !request.url.includes('RefreshToken') && !request.url.includes('Logging')) {

         if (this.isTokenExpired(currentUser.token)) {
            // token expired
            //Ez csak akkor forulhat elő, ha az időzített token frissítés nem fut valami miatt
            // pl. alvó állapotba kerül a gépünk
            // authentication.service -> startRefreshTokenTimer 
            //console.log("token expired");
            if (this.refreshTokenInProgress) {
               // If refreshTokenInProgress is true, we will wait until refreshTokenSubject has a non-null value
               // – which means the new token is ready and we can retry the request again
               return this.refreshTokenSubject.pipe(
                  filter(token => token != null),
                  take(1),
                  switchMap(token => {
                     //console.log("sw");
                     //console.log(request);
                        return next.handle(request);
                  })
               );
            } else {
               this.refreshTokenInProgress = true;

               // Set the refreshTokenSubject to null so that subsequent API calls will wait until the new token has been retrieved
               this.refreshTokenSubject.next(null);

               this.authenticationService.refreshToken().subscribe({
                  next: (result) => {
                     this.refreshTokenSubject.next(result);
                  },
                  error: (e) => {
                     this.newToken = null;
                  },
                  complete: () => {
                     this.refreshTokenInProgress = false;
                     //console.log("coml");
                     //return next.handle(request);
                 }
 
               });

            }

         } else {
            // token valid
            request = request.clone({
               setHeaders: {
                  Authorization: `Bearer ${currentUser.token}`
               }
            });
            //console.log("beare");
            //console.log(request);
            //console.log(currentUser.token);
   
            return next.handle(request);
           }


      } else {
         //Nincs bejelentkezett user
         return next.handle(request);
      }
   }

   isTokenExpired(token) {
      // parse json object from base64 encoded jwt token
      const jwtToken = JSON.parse(atob(token.split('.')[1]));

      // set a timeout to refresh the token a minute before it expires
      const expires = new Date(jwtToken.exp * 1000);
      const timeout = expires.getTime() - Date.now();
      return timeout < 0;
   }
}
